import { FetchResult } from "@apollo/client";

import { publishNodeInput, PublishNodeMutation } from "../../API";
import { IDeviceTableRow } from "../../pages/devices/hooks/useDeviceTableRows";
import { extractDeviceNameFromId } from "../utils/getEntityName";
import {
  errorNotification,
  successNotification,
} from "../variables/notification";

export const captureLiveImage = async (
  deviceDetail: IDeviceTableRow,
  publishNode: (
    args: publishNodeInput
  ) => Promise<
    FetchResult<
      PublishNodeMutation,
      Record<string, string>,
      Record<string, string>
    >
  >
): Promise<void> => {
  const { extractedDeviceName } = extractDeviceNameFromId(deviceDetail?.rowId);

  try {
    const response = await publishNode({
      message: JSON.stringify({
        ACTION: "SAVE_IMAGE",
        s3_key: deviceDetail?.deviceData?.recentFrame,
        TARGET: "CAMERA_MANAGER",
        device_id: extractedDeviceName,
        footer: "TRUE",
        ACK: deviceDetail?.node.id,
      }),
      nodeId: deviceDetail?.node.id ?? "",
    });

    if (response.data) {
      successNotification("A new live image is requested");
    }
  } catch (error) {
    errorNotification("Something went wrong, a new live image isn't captured");

    console.error(error);
  }
};
